import React, { useEffect, useState, useRef } from "react";
import { Card, Row, Form, Button, Col } from "react-bootstrap";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { Field, Formik, Form as FormikForm, useFormikContext } from "formik";
import * as Yup from "yup";
import { Link, useNavigate  } from "react-router-dom";
import FormikSelectField from "../../../../shared/components/FormikSelectField";
import FormTextField from "../../../../shared/components/FormTextField";

import "./TicketCreation.css";

import { loadStatusDropdownRequest } from "../../../vision_hub/escalation_rule_builder/redux/Actions";

import { loadCategorySubCategoryConfigDataRequest } from "../../../vision_hub/categories/redux/Actions";

import {
    GROUPBY_ID_JOBTITLE_GET_DATA,
    GROUPBYTYPE_ADMIN_GET_DATA,
} from "../../../group_jobtitles/redux/Constants";
import { addErrorAlert } from "../../../alert/Actions";
import {
    createTicketRequest,
    getAllUsersRequest,
    resetCreateTicket,
} from "../redux/Actions";

import { UPLOAD_FILES_LENGTH, BACKTOLIST, TICKET_CREATION, TICKETING } from "../../../../shared/constants/Constants";
import Breadcrumbs from "../../../../shared/components/Breadcrumbs";
import DefaultButton from "../../../../shared/components/DefaultButton";

const TICKET_TYPE_OPTIONS = [
  { value: "Ticket", label: "Ticket" },
  { value: "Workflow", label: "Workflow" },
];

export default function TicketCreation() {
  const empInfo = JSON.parse(localStorage.getItem("employee")) || {};
  const empId = empInfo.id || null;
  const emp_no = empInfo.emp_no || null;
  //let securityTab = false;
  //if (empInfo?.role === "admin") {  securityTab = true; }
  const ticketemployees = ["134321","105729"];
  const hasTicketAccess =  empInfo?.role === "admin" || ticketemployees.includes(String(emp_no));  
  const employeeName = `${empInfo.first_name || ""} ${empInfo.last_name || ""}`;
  const storeName = empInfo.store_name || "";
  const storeId = empInfo.store_id || null;
  const marketName = empInfo.market_name || "";
  const marketId = empInfo.market_id || null;
  const regionName = empInfo.region_name || "";
  const regionId = empInfo.region_id || null;
  // New
  const MAX_VISIBLE_TABS = 5;
  const [startIndex, setStartIndex] = useState(0);
  const [showOverflowMenu, setShowOverflowMenu] = useState(false);

  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const overflowRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const formikRef = useRef(null);
  const [selectedUserCompanyId, setSelectedUserCompanyId] = useState(null);
    

  // categoryconfig from categories reducer
  const categoryconfig = useSelector(
    (store) => store.categories.categoryconfig?.data || []
  );

  const { statusList, loadingStatus } = useSelector(
    (state) => state.ticketingDropdowns,
    shallowEqual
  );

  const { users, loadingUsers, errorUsers } = useSelector(
    (state) => state.allUsers,
    shallowEqual
  );
  const { adminGroup, group } = useSelector(
    (state) => state.groupJobtitle,
    shallowEqual
  );

  const userRole = "admin"; //login?.role;

  const { createSuccess, createError, updating } = useSelector(
    (state) => state.createTicket
  );

  // Keep a state for categoryOptions for compatibility with existing code (but we'll populate from categoryconfig)
  const [allCategoryOptions, setAllCategoryOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [subCategoryOptions, setSubCategoryOptions] = useState([]); // NEW state for subcategories
  const [usersAttempted, setUsersAttempted] = useState(false);
  const [categoryAttempted, setCategoryAttempted] = useState(false);
  const [statusAttempted, setStatusAttempted] = useState(false);
  const companyName = empInfo.company_name || "";

  const [workflowSteps, setWorkflowSteps] = useState([]);

  const visibleTabs = workflowSteps.slice(
    startIndex,
    startIndex + MAX_VISIBLE_TABS
  );

  const overflowTabs = workflowSteps.slice(startIndex + MAX_VISIBLE_TABS);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        showOverflowMenu &&
        overflowRef.current &&
        !overflowRef.current.contains(e.target)
      ) {
        setShowOverflowMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showOverflowMenu]);

  useEffect(() => {
    if (!workflowSteps.length) return;

    if (activeTabIndex < startIndex) {
      setStartIndex(activeTabIndex);
      return;
    }

    if (activeTabIndex >= startIndex + MAX_VISIBLE_TABS) {
      setStartIndex(activeTabIndex - MAX_VISIBLE_TABS + 1);
    }
  }, [activeTabIndex, workflowSteps.length, startIndex]);

  // Load admin groups based on user role
  useEffect(() => {
    if (userRole) {
      dispatch({
        type: GROUPBYTYPE_ADMIN_GET_DATA.GROUPBYTYPE_ADMIN_GET_DATA_LOAD,
        role: userRole,
      });
    }
  }, [dispatch, userRole]);

  // Load status dropdown (unchanged)
  useEffect(() => {
    if (!statusAttempted && !loadingStatus && statusList.length === 0) {
      setStatusAttempted(true);
      dispatch(loadStatusDropdownRequest());
    }
    if (!usersAttempted && !loadingUsers && users.length === 0) {
      setUsersAttempted(true);
      dispatch(getAllUsersRequest());
    }
  }, [
    dispatch,
    loadingStatus,
    statusList.length,
    statusAttempted,
    usersAttempted,
    loadingUsers,
    users.length,
  ]);

  // Load category + subcategory config from categories reducer via new action
  useEffect(() => {
    // If categoryconfig is empty and we haven't attempted, dispatch the loader
    if (
      !categoryAttempted &&
      (!Array.isArray(categoryconfig) || categoryconfig.length === 0)
    ) {
      setCategoryAttempted(true);
      dispatch(loadCategorySubCategoryConfigDataRequest());
    }
    // If categoryconfig is present, populate categoryOptions
    if (Array.isArray(categoryconfig) && categoryconfig.length > 0) {
      // Map to options with full object included
      const opts = categoryconfig.map((cat) => ({
        id: cat.id,
        value: cat.id,
        label: cat.name, // show `name` as requested (Option A)
        subcategories: cat.sub_category || [],
        raw: cat,
      }));
      setAllCategoryOptions(opts);
      setCategoryOptions(opts);
    }
  }, [dispatch, categoryconfig, categoryAttempted]);

  // if document drag and drop outside the zone or box it will not open in new tab
  useEffect(() => {
    const preventDefault = (e) => {
      e.preventDefault();
      e.stopPropagation();
    };

    // Prevent browser from opening files when dropped outside dropzone
    window.addEventListener("dragover", preventDefault);
    window.addEventListener("drop", preventDefault);

    return () => {
      window.removeEventListener("dragover", preventDefault);
      window.removeEventListener("drop", preventDefault);
    };
  }, []);

  useEffect(() => {
    if (createSuccess) {
      // Reset the form
      if (formikRef.current) {
        formikRef.current.resetForm();
      }

      // Reset redux flags
      dispatch(resetCreateTicket());
    }

    if (createError) {
      // Reset redux flags
      dispatch(resetCreateTicket());
    }
  }, [createSuccess, createError]);

  // Filter categories by ticket type — keep existing function for compatibility
  const filterCategoriesByTicketType = (ticketType, companyId = null) => {
    if (!allCategoryOptions.length) return;

    const filtered = allCategoryOptions
      .filter((item) => {
        if (item.raw?.ticket_type !== undefined) {
          if (String(item.raw.ticket_type) !== String(ticketType)) return false;
        }
        // If companyId provided, only include categories that have
        // at least one subcategory matching that company
        if (companyId) {
          return (item.subcategories || []).some(
            (sc) => Number(sc.company_id) === Number(companyId)
          );
        }
        return true;
      })
      .map((item) => ({
        ...item,
        // Pre-filter subcategories to only this company's entries
        subcategories: companyId
          ? (item.subcategories || []).filter(
              (sc) => Number(sc.company_id) === Number(companyId)
            )
          : item.subcategories,
      }));

    setCategoryOptions(filtered);
  };

  // Update filtered category options when ticketType or categoryconfig changes (compatibility)
  useEffect(() => {
    if (formikRef.current) {
      const ticketType = formikRef.current.values.ticketType || "Ticket";
      filterCategoriesByTicketType(ticketType);
    }
  }, [allCategoryOptions]);

  const validationSchema = Yup.object({
    ticketType: Yup.string().required("Ticket Type is required."),
    category: Yup.string().required("Category is required."),
    subCategory: Yup.string().required("Sub Category is required."),
    requestUser: Yup.string().when("ticketType", {
      is: "Ticket",
      then: (s) => s.required("Request User is required."),
      otherwise: (s) => s.notRequired(),
    }),
    status: Yup.string().required("Status is required."),
    adminGroup: Yup.string().when("ticketType", {
      is: "Ticket",
      then: (s) => s.required("Admin Group is required"),
      otherwise: (s) => s.notRequired(),
    }),
    // assignedTo: Yup.string().required("Assigned User is required."),
    summary: Yup.string().required("Summary is required."),
    description: Yup.string().required("Description is required."),
  });

  // if you want helper to get selected sub object from current form values
  const findSelectedSubCategory = (categoryId, subId, ticketType) => {
    const category = categoryconfig.find(
      (c) => Number(c.id) === Number(categoryId) && c.ticket_type === ticketType
    );
    if (!category || !Array.isArray(category.sub_category)) return null;
    return category.sub_category.find((s) => Number(s.s_id) === Number(subId));
  };

  const handleFileUpload = (selectedFiles, values, setFieldValue) => {
    const allowedExtensions = [
      "png",
      "jpg",
      "jpeg",
      "gif", 
      "pdf",
      "xlsx",
      "doc",
      "docx",
      "xls",
      "mp4",
    ];
    const maxSize = 10 * 1024 * 1024; // 10 MB

    // Too many at once
    if (selectedFiles.length > UPLOAD_FILES_LENGTH) {
      dispatch(
        addErrorAlert(
          `You can upload max ${UPLOAD_FILES_LENGTH} files at a time.`
        )
      );
      return;
    }

    // Too many in total
    if (
      values.attachments.length + selectedFiles.length >
      UPLOAD_FILES_LENGTH
    ) {
      dispatch(
        addErrorAlert(
          `Maximum ${UPLOAD_FILES_LENGTH} attachments allowed. You already uploaded ${values.attachments.length}.`
        )
      );
      return;
    }

    // Validate each file
    for (let file of selectedFiles) {
      const ext = file.name.split(".").pop().toLowerCase();

      if (!allowedExtensions.includes(ext)) {
        dispatch(addErrorAlert(`Invalid file type: ${file.name}`));
        return;
      }

      if (file.size > maxSize) {
        dispatch(
          addErrorAlert(`File too large: ${file.name}. Max size is 10MB.`)
        );
        return;
      }
    }

    // Add files to formik
    setFieldValue("attachments", [...values.attachments, ...selectedFiles]);
  };

  const lastRequestedDeptRef = useRef(null);

  useEffect(() => {
    const step = workflowSteps[activeTabIndex];
    if (!step || step.usersLoaded) return;

    lastRequestedDeptRef.current = step.departmentId;

    dispatch({
      type: GROUPBY_ID_JOBTITLE_GET_DATA.GROUPBY_ID_JOBTITLE_GET_DATA_LOAD,
      id: step.departmentId,
    });
  }, [activeTabIndex, workflowSteps, dispatch]);

  useEffect(() => {
    if (!group?.length) return;
    if (!workflowSteps.length) return;
    console.log(
      "Updating workflow steps with users for dept:",
      lastRequestedDeptRef.current
    );
    console.log("Users fetched:", group);
    const deptId = lastRequestedDeptRef.current;
    if (!deptId) return;

    setWorkflowSteps((prev) =>
      prev.map((step) => {
        if (step.departmentId !== deptId || step.usersLoaded) {
          return step;
        }

        return {
          ...step,
          users: group.map((u) => ({
            id: String(u.id),
            name: u.emp_name ?? u.name,
            employeeId: u.employee_id,
          })),
          usersLoaded: true,
        };
      })
    );
  }, [group]);

  const handleSaveTicket = async () => {
    if (updating) return;

    const errors = await formikRef.current.validateForm();
    formikRef.current.setTouched(
      Object.keys(formikRef.current.values).reduce((acc, key) => {
        acc[key] = true;
        return acc;
      }, {})
    );

    if (Object.keys(errors).length > 0) {
      dispatch(addErrorAlert("Please check all required fields."));
      return;
    }

    const values = formikRef.current.values;

    // ============================
    // WORKFLOW TICKET
    // ============================
    if (values.ticketType === "Workflow") {
      if (!workflowSteps.length) {
        dispatch(addErrorAlert("No workflow departments configured"));
        return;
      }

      const selectedSub = findSelectedSubCategory(
        values.category,
        values.subCategory,
        values.ticketType,
      );

      if (!selectedSub?.config_id) {
        dispatch(addErrorAlert("Invalid category configuration"));
        return;
      }

      const workflowFormData = new FormData();

      // COMMON FIELDS
      workflowFormData.append("ticket_type", values.ticketType);
      workflowFormData.append(
        "category_config_id",
        Number(selectedSub.config_id)
      );
      workflowFormData.append("summary", values.summary);
      workflowFormData.append("description", values.description);
      workflowFormData.append("status_id", Number(values.status));
      workflowFormData.append("requested_for", Number(empId));

      if (!storeId || !marketId || !regionId) {
        dispatch(
          addErrorAlert("Employee store, market, or region is required.")
        );
        return;
      }

      storeId && workflowFormData.append("store_id", Number(storeId));
      marketId && workflowFormData.append("market_id", Number(marketId));
      regionId && workflowFormData.append("region_id", Number(regionId));

      // WORKFLOW STEPS
      const workflowPayload = workflowSteps.map((step) => ({
        department_id: step.departmentId,
        assigned_to: step.assignedToId || null,
        instructions: step.instructions || "",
        order: step.order,
      }));

      workflowFormData.append(
        "workflow_tickets",
        JSON.stringify(workflowPayload)
      );

      // ATTACHMENTS
      values.attachments?.forEach((file) => {
        workflowFormData.append("attachments", file);
      });

      dispatch(createTicketRequest(workflowFormData));
      return;
    }

    // ============================
    // STANDARD TICKET
    // ============================
    const selectedUser = users.find((u) => u.id === Number(values.requestUser));

    if (!selectedUser) {
      dispatch(addErrorAlert("Invalid Request User"));
      return;
    }

    const formData = new FormData();

    const selectedSub = findSelectedSubCategory(
      values.category,
      values.subCategory,
      values.ticketType,
    );

    formData.append("category_config_id", Number(selectedSub?.config_id));
    formData.append("summary", values.summary);
    formData.append("description", values.description);
    formData.append("status_id", Number(values.status));

    if (
      !selectedUser.store_id ||
      !selectedUser.market_id ||
      !selectedUser.region_id
    ) {
      dispatch(addErrorAlert("Employee store, market, or region is required."));
      return;
    }

    formData.append("store_id", Number(selectedUser.store_id));
    formData.append("market_id", Number(selectedUser.market_id));
    formData.append("region_id", Number(selectedUser.region_id));
    formData.append("requested_for", Number(values.requestUser));

    if (selectedUser.company_id) {
      formData.append("company_id", Number(selectedUser.company_id));
    }

    if (values.assignedTo) {
      formData.append("assigned_to", Number(values.assignedTo));
    }

    if (values.adminGroup) {
      formData.append("assigned_to_admin_group", Number(values.adminGroup));
    }

    values.attachments?.forEach((file) => {
      formData.append("attachments", file);
    });

    dispatch(createTicketRequest(formData));
  };

  useEffect(() => {
    if (createSuccess) {
      navigate("/ticketing/");
    }
  }, [createSuccess, navigate]);

  return (
    <>
      <Row className="detailsPageHeader">
        <Col>
          <Breadcrumbs
            children={[
              { href: "/ticketing/", label: TICKETING },
              { href: "/ticketcreation", label: TICKET_CREATION },
            ]}
          />
        </Col>
        <Col xl={8} xs={12}>
          <div className="float-end">
            <Link to="/ticketing/">
              <DefaultButton
                buttonClass="default-btn-color"
                buttonTitle={BACKTOLIST}
              />
            </Link>
          </div>
        </Col>
      </Row>
      <Card className="p-4 shadow-sm bg-white ticketCreation">
        <Formik
          innerRef={formikRef}
          enableReinitialize={true}
          validationSchema={validationSchema}
          initialValues={{
            ticketType: "Ticket",
            category: "",
            subCategory: "", // NEW field for sub category
            requestUser: "",
            status: statusList[0]?.value || "",
            adminGroup: "",
            assignedTo: "",
            sap: "",
            district: "",
            region: "",
            company: "",
            summary: "",
            description: "",
            attachments: [],
          }}
        >
          {({
            values,
            setFieldValue,
            setFieldTouched,
            errors,
            touched,
            setFieldError,
          }) => {
            // New
            const isWorkflow = values.ticketType === "Workflow";
            const isTicket = values.ticketType === "Ticket";
            const activeWorkflowStep = workflowSteps[activeTabIndex];

            return (
              <FormikForm>
                <Row className="g-3">
                  {/* Ticket Type */}
                  <FormikSelectField
                    name="ticketType"
                    label="Ticket Type"
                    required
                    value={values.ticketType}
                    onChange={(name, value) => {
                                setFieldValue(name, value);
                                setFieldTouched(name, false);
                                setFieldError(name, undefined);
                                setFieldValue("category", "", false);
                                setFieldValue("subCategory", "", false);
                                setSelectedUserCompanyId(null); // clear company filter on type switch
                                filterCategoriesByTicketType(value, null); // no company filter for Workflow
                              }}
                    isInvalid={touched.ticketType && !!errors.ticketType}
                    error={errors.ticketType}
                  >
                     {TICKET_TYPE_OPTIONS.map((option) => ( 
                      /* {(hasTicketAccess ? TICKET_TYPE_OPTIONS : TICKET_TYPE_OPTIONS.filter(opt => opt.value === "Ticket")).map((option) => ( */
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </FormikSelectField>
                    {!isWorkflow && (
                      <FormikSelectField
                        name="requestUser"
                        label="Request User"
                        required
                        value={values.requestUser}
                        onChange={(name, value) => {
                                  setFieldValue(name, value);
                                  setFieldTouched(name, false);
                                  setFieldError(name, undefined);

                                  const selected = users.find((u) => u.id === Number(value));

                                  setFieldValue("sap", selected?.store_name || "");
                                  setFieldValue("district", selected?.market_name || "");
                                  setFieldValue("region", selected?.region_name || "");
                                  setFieldValue("company", selected?.company_name || ""); 

                                  // Reset category + subcategory
                                  setFieldValue("category", "", false);
                                  setFieldValue("subCategory", "", false);
                                  setSubCategoryOptions([]);

                                  // Filter categories by this user's company
                                  const companyId = selected?.company_id || null;
                                  setSelectedUserCompanyId(companyId);
                                  filterCategoriesByTicketType(formikRef.current.values.ticketType, companyId);
                                }}
                        isInvalid={touched.requestUser && !!errors.requestUser}
                        error={errors.requestUser}
                      >
                        <option value="">-- Select Request User --</option>

                        {users.map((u) => (
                          <option key={u.id} value={String(u.id)}>
                            {u.name}, {u.employee_id}
                          </option>
                        ))}
                      </FormikSelectField>
                    )}

                    {/* Status */}
                  <FormikSelectField
                    name="status"
                    label="Status"
                    required
                    value={values.status}
                    onChange={(name, value) => {
                      setFieldValue(name, value);
                      setFieldTouched(name, false);
                      setFieldError(name, undefined);
                    }}
                    isInvalid={touched.status && !!errors.status}
                    error={errors.status}
                  >
                    <option value="">-- Select Status --</option>
                    {statusList.map((item) => (
                      <option key={item.value} value={item.value}>
                        {item.label}
                      </option>
                    ))}
                  </FormikSelectField>
                  </Row>  

                  <Row className="g-3 mt-2">
                  {/* Category (shows cat.name) */}
                  <FormikSelectField
                    name="category"
                    label="Categories"
                    required
                    value={values.category}
                    onChange={(name, value) => {
                      setFieldValue(name, value);
                      setFieldTouched(name, false);
                      setFieldError(name, undefined);

                      // find selected category from categoryconfig
                      const selectedCat = categoryOptions.find(
                        (c) => Number(c.value) === Number(value)
                      );
                      const subcats = selectedCat?.subcategories || [];
                      setSubCategoryOptions(subcats);

                      // reset subCategory value when category changes
                      setFieldValue("subCategory", "", false);

                      // clear adminGroup and assignedTo when category changes
                      setFieldValue("adminGroup", "");
                      setFieldValue("assignedTo", "");
                    }}
                    isInvalid={touched.category && !!errors.category}
                    error={errors.category}
                  >
                    <option value="">-- Select Category --</option>
                    {categoryOptions.map((cat) => (
                      <option key={cat.id} value={String(cat.value)}>
                        {cat.label}
                      </option>
                    ))}
                  </FormikSelectField>

                  {/* Sub Category  */}

                  <FormikSelectField
                    name="subCategory"
                    label="Sub Category"
                    required
                    value={values.subCategory}
                    disabled={!values.category} // disable when category is not selected
                    onChange={(name, value) => {
                      setFieldValue(name, value);

                      const selected = subCategoryOptions.find(
                        (s) => Number(s.s_id) === Number(value)
                      );

                      if (selected) {
                        if (isTicket) {
                          // auto-fill admin group
                          setFieldValue(
                            "adminGroup",
                            String(selected.admin_group) || ""
                          );

                          if (selected.admin_group) {
                            dispatch({
                              type: GROUPBY_ID_JOBTITLE_GET_DATA.GROUPBY_ID_JOBTITLE_GET_DATA_LOAD,
                              id: selected.admin_group,
                            });
                          }
                          // auto-fill assigned to
                          setFieldValue(
                            "assignedTo",
                            selected.assigned_to || ""
                          );

                          // auto-fill description with questions
                          if (Array.isArray(selected.questions)) {
                            const questionText = selected.questions
                              .map((q) => q.question_text)
                              .join("\n");
                            setFieldValue("description", questionText);
                          }
                        }
                        if (isWorkflow) {
                          const steps = (selected.childDepartments || [])
                            .slice()
                            .sort((a, b) => a.order - b.order)
                            .map((d) => ({
                              id: d.id,
                              departmentId: d.departmentId,
                              departmentName: d.departmentName,
                              instructions: d.instructions || "",
                              assignedToId:
                                d.assignedToId != null
                                  ? String(d.assignedToId)
                                  : "",
                              order: d.order,
                              users: [],
                              usersLoaded: false,
                            }));

                          setWorkflowSteps(steps);
                          setActiveTabIndex(0);
                          setStartIndex(0);
                          setShowOverflowMenu(false);
                        }
                      } else {
                        setFieldValue("adminGroup", "");
                        setFieldValue("assignedTo", "");
                      }
                    }}
                    isInvalid={touched.subCategory && !!errors.subCategory}
                    error={errors.subCategory}
                  >
                    <option value="">
                      {values.category
                        ? "-- Select Sub Category --"
                        : "Select Category First"}
                    </option>

                    {subCategoryOptions.map((sc) => (
                      <option key={sc.s_id} value={String(sc.s_id)}>
                        {sc.s_name}
                      </option>
                    ))}
                  </FormikSelectField>         
                  

                  {/* Admin Group */}
                  {!isWorkflow && ( // New
                    <FormikSelectField
                      name="adminGroup"
                      label="Admin Group"
                      required
                      value={values.adminGroup}
                      onChange={(name, value) => {
                        setFieldValue(name, value);
                        setFieldTouched(name, false);
                        setFieldError(name, undefined);
                        dispatch({
                          type: GROUPBY_ID_JOBTITLE_GET_DATA.GROUPBY_ID_JOBTITLE_GET_DATA_LOAD,
                          id: value,
                        });
                        setFieldValue("assignedTo", "");
                      }}
                      isInvalid={touched.adminGroup && !!errors.adminGroup}
                      error={errors.adminGroup}
                    >
                      <option value="">-- Select Admin Group --</option>
                      {adminGroup.map((g) => (
                        <option
                          key={g.group_id ?? g.id}
                          value={String(g.group_id ?? g.id)}
                        >
                          {g.group_name}
                        </option>
                      ))}
                    </FormikSelectField>
                  )}

                  {/* Assigned To */}
                  {!isWorkflow && ( // New
                    <FormikSelectField
                      name="assignedTo"
                      label="Assigned To"
                      value={values.assignedTo}
                      onChange={(name, value) => {
                        setFieldValue(name, value);
                        setFieldTouched(name, false);
                        setFieldError(name, undefined);
                      }}
                    >
                      <option value="">-- Select User --</option>
                      {(Array.isArray(group) ? group : []).map((user) => (
                        <option key={user.id} value={String(user.id)}>
                          {user.emp_name ?? user.name}, {user.employee_id}
                        </option>
                      ))}
                    </FormikSelectField>
                  )}
                  {isWorkflow && (
                    <FormikSelectField
                      name="requestUser"
                      label="Request User"
                      required
                      value={empId}
                      disabled={isWorkflow}
                      // isInvalid={touched.requestUser && !!errors.requestUser}
                      // error={errors.requestUser}
                    >
                      <option value={empId}>{employeeName}, {emp_no || "--"}</option>
                    </FormikSelectField>
                  )}
                </Row>
                <Row className="g-2 mt-2">
                    <Col md={3}>
                      <Form.Group>
                        <Form.Label>Store</Form.Label>
                        <Form.Control
                          type="text"
                          value={isWorkflow ? storeName || "--" : values.sap || "--"}
                          readOnly
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group>
                        <Form.Label>Market</Form.Label>
                        <Form.Control
                          type="text"
                          value={isWorkflow ? marketName || "--" : values.district || "--"}
                          readOnly
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group>
                        <Form.Label>Region</Form.Label>
                        <Form.Control
                          type="text"
                          value={isWorkflow ? regionName || "--" : values.region || "--"}
                          readOnly
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group>
                        <Form.Label>Company</Form.Label>
                        <Form.Control
                          type="text"
                          value={isWorkflow ? companyName || "--" : values.company || "--"}
                          readOnly
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                <Row className="g-3 mt-3">
                  <FormTextField
                    name="summary"
                    label="Subject"
                    maxLength={50}
                    required
                    placeholder="Enter ticket summary"
                    isInvalid={touched.summary && !!errors.summary}
                    error={errors.summary}
                  />
                </Row>

                <Row className="my-3">
                  <div className="col-md-12">
                    <Form.Label htmlFor="description">
                      Description <span className="text-danger">*</span>
                    </Form.Label>

                    <Field
                      as="textarea"
                      className={`form-control ${
                        touched.description && errors.description
                          ? "is-invalid"
                          : ""
                      }`}
                      rows={7}
                      style={{ minHeight: "200px" }}
                      name="description"
                      id="description"
                      placeholder="Enter ticket description"
                      onChange={(e) => {
                        setFieldValue("description", e.target.value);
                        setFieldTouched("description", true, false);
                      }}
                      onBlur={() => setFieldTouched("description", true)}
                    />

                    {touched.description && errors.description && (
                      <div
                        className="text-danger mt-1"
                        style={{
                          whiteSpace: "pre-wrap",
                          fontSize: "0.875rem",
                        }}
                      >
                        {errors.description}
                      </div>
                    )}
                  </div>
                </Row>
                {/* ================= WORKFLOW SECTION ================= */}
                {isWorkflow &&
                  values.subCategory && ( // New
                    <div className="mt-4">
                      {/* WORKFLOW TABS HEADER */}
                      <div className="d-flex align-items-center mb-3 ">
                        {/* FIXED-WIDTH TABS CONTAINER */}
                        <div
                          style={{
                            width: "1000px",
                            overflow: "hidden",
                          }}
                        >
                          <div className="d-flex">
                            {visibleTabs.map((tab, index) => {
                              const realIndex = startIndex + index;
                              const isActive = activeTabIndex === realIndex;

                              return (
                                <div
                                  key={tab.id}
                                  onClick={() => setActiveTabIndex(realIndex)}
                                  className={`workflow-tab ${
                                    isActive ? "selected" : ""
                                  }`}
                                  title={`${tab.order}. ${tab.departmentName}`}
                                  style={{ cursor: "pointer" }}
                                >
                                  {tab.order}. {tab.departmentName}
                                </div>
                              );
                            })}
                          </div>
                        </div>

                        {/* THREE DOTS OVERFLOW */}

                        {overflowTabs.length > 0 && (
                          <div
                            className="position-relative ms-2"
                            ref={overflowRef}
                          >
                            <div
                              onClick={() => setShowOverflowMenu((v) => !v)}
                              className="workflow-overflow-dots"
                              style={{ marginLeft: "20px" }}
                            >
                              <i
                                className="fas fa-ellipsis-v"
                                style={{ fontSize: "18px" }}
                              />
                            </div>
                            {showOverflowMenu && (
                              <div
                                style={{
                                  position: "absolute",
                                  top: "100%",
                                  right: 0,
                                  zIndex: 1000,
                                  minWidth: "220px",
                                  maxHeight: "260px",
                                  overflowY: "auto",
                                  background: "#fff",
                                  border: "1px solid #ddd",
                                  borderRadius: "6px",
                                  boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
                                }}
                              >
                                {overflowTabs.map((tab, i) => {
                                  const realIndex =
                                    startIndex + MAX_VISIBLE_TABS + i;

                                  return (
                                    <div
                                      key={tab.id}
                                      onClick={() => {
                                        setActiveTabIndex(realIndex);

                                        const newStart = Math.min(
                                          Math.max(
                                            realIndex -
                                              Math.floor(MAX_VISIBLE_TABS / 2),
                                            0
                                          ),
                                          Math.max(
                                            workflowSteps.length -
                                              MAX_VISIBLE_TABS,
                                            0
                                          )
                                        );

                                        setStartIndex(newStart);
                                        setShowOverflowMenu(false);
                                      }}
                                      style={{
                                        padding: "8px 12px",
                                        cursor: "pointer",
                                        borderBottom: "1px solid #eee",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      {tab.order}. {tab.departmentName}
                                    </div>
                                  );
                                })}
                              </div>
                            )}
                          </div>
                        )}
                      </div>

                      {/* Selected Tab Title */}
                      <div
                        style={{
                          fontSize: "18px",
                          fontWeight: 550,
                          color: "#070a0eff",
                          marginBottom: "10px",
                        }}
                      >
                        {activeWorkflowStep?.departmentName}
                      </div>
                      <hr />

                      {/* Assigned To (Workflow only) */}
                      <FormikSelectField
                        name="assignedToWorkflow"
                        label="Assigned To"
                        value={activeWorkflowStep?.assignedToId || ""}
                        onChange={(name, value) => {
                          setWorkflowSteps((prev) =>
                            prev.map((step, index) =>
                              index === activeTabIndex
                                ? { ...step, assignedToId: value || "" }
                                : step
                            )
                          );
                        }}
                      >
                        <option value="">-- Select User --</option>

                        {(activeWorkflowStep?.users || []).map((user) => (
                          <option key={user.id} value={user.id}>
                            {user.name}, {user.employeeId}
                          </option>
                        ))}
                      </FormikSelectField>

                      <div className="col-md-12 mt-3">
                        <Form.Label htmlFor="instruction">
                          Instruction <span className="text-danger">*</span>
                        </Form.Label>

                        <textarea
                          className="form-control"
                          rows={7}
                          style={{ minHeight: "200px" }}
                          value={activeWorkflowStep?.instructions || ""}
                          onChange={(e) => {
                            const value = e.target.value;

                            setWorkflowSteps((prev) =>
                              prev.map((step, index) =>
                                index === activeTabIndex
                                  ? { ...step, instructions: value }
                                  : step
                              )
                            );
                          }}
                          placeholder="Enter instructions for this department"
                        />
                      </div>
                      {/* Navigation Buttons */}
                      <div className="d-flex justify-content-between mt-3">
                        <button
                          type="button"
                          disabled={activeTabIndex === 0}
                          onClick={() => {
                            setActiveTabIndex((prev) => prev - 1); // FIX
                          }}
                          className="workflow-nav-btn"
                          style={{
                            opacity: activeTabIndex === 0 ? 0.5 : 1,
                            cursor:  activeTabIndex === 0 ? "not-allowed" : "pointer",
                          }}
                        >
                          ← Previous
                          {activeTabIndex > 0 &&
                            `: ${
                              workflowSteps[activeTabIndex - 1]?.departmentName
                            }`}
                        </button>

                        <button
                          type="button"
                          disabled={activeTabIndex === workflowSteps.length - 1} // FIX
                          onClick={() => {
                            if (activeTabIndex < workflowSteps.length - 1) {
                              setActiveTabIndex((prev) => prev + 1);
                            }
                          }}
                          className="workflow-nav-btn"
                          style={{
                            opacity: activeTabIndex === workflowSteps.length - 1 ? 0.5 : 1,
                            cursor:  activeTabIndex === workflowSteps.length - 1 ? "not-allowed" : "pointer",
                          }}
                        >
                          {activeTabIndex === workflowSteps.length - 1
                            ? "Completed"
                            : `Next: ${
                                workflowSteps[activeTabIndex + 1]
                                  ?.departmentName
                              } →`}
                        </button>
                      </div>
                    </div>
                  )}

                <Row className="my-3 mt-3">
                  <div className="col-md-12 mb-2">
                    {/* HEADER WITH BUTTON */}
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <Form.Label className="fw-bold mb-0">
                        Attachments
                      </Form.Label>

                      <Button
                        type="button"
                        className="btn default-btn-color"
                        onClick={() =>
                          document.getElementById("fileUpload").click()
                        }
                        disabled={
                          values.attachments.length >= UPLOAD_FILES_LENGTH
                        }
                      >
                        Choose Files
                      </Button>
                    </div>

                    {/* HIDDEN INPUT */}
                    <input
                      id="fileUpload"
                      type="file"
                      multiple
                      accept=".png,.jpg,.jpeg,.gif,.pdf,.xlsx,.doc,.docx,.xls,.mp4"
                      style={{ display: "none" }}
                      onChange={(e) => {
                        handleFileUpload(
                          Array.from(e.target.files),
                          values,
                          setFieldValue
                        );
                        e.target.value = "";
                      }}
                    />

                    {/* DROPZONE BOX */}
                    <div
                      className="dropzone"
                      onDragOver={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                      }}
                      onDrop={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleFileUpload(
                          Array.from(e.dataTransfer.files),
                          values,
                          setFieldValue
                        );
                      }}
                    >
                      {/*  SHOW DRAG MESSAGE ONLY IF NO FILES */}
                      {values.attachments.length === 0 && (
                        <div className="text-center text-muted">
                          <p className="mb-1">Drag & drop files here</p>
                          <p className="mb-0">or click "Choose Files"</p>
                        </div>
                      )}

                      {/* SHOW FILES INSIDE BOX */}
                      {values.attachments.length > 0 && (
                        <div className="attachments-container">
                          {values.attachments.map((file, index) => (
                            <div className="attachment-card" key={index}>
                              <div className="attachment-info">
                                <span className="file-name">{file.name}</span>
                                <span className="file-size">
                                  {(file.size / 1024 / 1024).toFixed(2)} MB
                                </span>
                              </div>

                              {/* Delete Icon */}
                              <span
                                className="delete-icon"
                                onClick={() =>
                                  setFieldValue(
                                    "attachments",
                                    values.attachments.filter(
                                      (_, i) => i !== index
                                    )
                                  )
                                }
                              >
                                <i className="fa fa-trash"></i>
                              </span>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </Row>
                <Row className="mt-4">
                  <div className="col-md-12 d-flex justify-content-end gap-2">
                    <Button type="button" variant="secondary">
                      Cancel
                    </Button>
                    <Button
                      type="button"
                      className="btn default-btn-color"
                      disabled={updating}
                      onClick={handleSaveTicket}
                    >
                      {updating ? "Saving..." : "Save"}
                    </Button>
                  </div>
                </Row>
              </FormikForm>
            );
          }}
        </Formik>
      </Card>
    </>
  );
}
